import { createStore, Store } from 'vuex';

import auth from './auth';
import notifications from './notifications';
import courses from './courses';
import projects from './projects';
import files from './files';
import conversations from './conversations';
import subscriptions from './subscriptions';
import feedback from './feedback';

import { state, RootStateI } from './state';
import { mutations } from './mutations';

const store: Store<RootStateI> = createStore({
  state,
  getters: {
  },
  mutations,
  actions: {
  },
  modules: {
  },
});

store.registerModule('auth', auth);
store.registerModule('notifications', notifications);
store.registerModule('courses', courses);
store.registerModule('projects', projects);
store.registerModule('files', files);
store.registerModule('conversations', conversations);
store.registerModule('subscriptions', subscriptions);
store.registerModule('feedback', feedback);

export default store;
